<template>
   <div class="target-achievement-container" v-click-outside="handlerOutClick" :class="showIcon ? 'navbar-style' : ''" :style="response == null ? 'margin-bottom:0!important' : ''">
      <template v-if="showIcon">
         <div class="target-achievement-icon-wrapper" @click="handlerTargetAchievementStatus">
            <UITooltip :tooltip-title="$t('aside_targetAchievements')" tooltip-icon="gts-icon icon-target-achievement icon-navbar gts-animation" tooltip-position="bottom"></UITooltip>
         </div>
      </template>

      <div class="target-achievement-wrapper" v-if="showDropdown && response != null">
         <template v-if="response == null">
            <div class="widget-loader-wrapper">
               <span class="g-radial-loader"> </span>
            </div>
         </template>
         <template>
            <div class="target-achievement-inner-wrapper">
               <Confetti v-if="showConfetti" />
               <template v-for="(product, key, index) in Targets">
                  <div class="achievement" :class="key" :key="index">
                     <!-- @mouseenter="showProgressTooltip = true" @mouseleave="showProgressTooltip = false" -->
                     <section class="achievement-left">
                        <div class="achievement-informations-wrapper">
                           <span class="achievement-name">{{ product.name }} {{ $t("targetAchievement_lblTitle") }}</span>
                           <span class="achievement-percentage"></span>
                        </div>
                        <!-- Progress Bar  -->
                        <!-- @mouseenter="showProgressTooltip = true" @mouseleave="showProgressTooltip = false" -->
                        <div class="progress-bar-wrapper">
                           <div class="progress-bar" :class="key" :data-value="product.current"></div>

                           <div class="progress-tooltip" v-show="key == 'hotel'">
                              <span v-show="showProgressTooltip">{{ product?.currentAsPrice | price }}</span>
                              <span>&nbsp;</span>
                           </div>
                        </div>

                        <!-- Progress Bar Indicators -->
                        <template v-if="key == 'hotel'">
                           <div class="progress-bar-indicators-wrapper">
                              <ul class="indicators">
                                 <li v-for="index in 16" :key="index"></li>
                              </ul>
                              <ul class="indicators-infos">
                                 <li>0€</li>

                                 <li>{{ $t("targetAchievement_lblTarget") }}: {{ product?.targetAsPrice | price }}</li>
                              </ul>
                           </div>
                        </template>
                     </section>
                     <section class="achievement-right">
                        <div class="achievement-emoji"></div>
                     </section>
                  </div>
               </template>
            </div>
         </template>

         <div class="info-bar-wrapper">
            <i class="info-icon"></i>
            <span class="info-text"> {{ MomentFromTo }} -{{ $t("targetAchievement_lblInformaton") }}</span>
         </div>
      </div>
   </div>
</template>

<script>
import gsap from "gsap";
import { globalService } from "@/service/index.js";
import UITooltip from "@/components/utils/GtsToolTips.vue";
import Confetti from "@/components/structural/dashboard/ConfettiParticles.vue";
import moment from "moment";
export default {
   name: "TargetAchivement",
   components: {
      UITooltip,
      Confetti,
   },
   props: {
      showIcon: Boolean,
   },
   data() {
      return {
         showDropdown: false,
         response: null,
         showConfetti: false,
         confettiCookieControl: false,
         showProgressTooltip: true,
      };
   },
   computed: {
      Targets() {
         return this.response;
      },
      MomentFromTo() {
         const startOfYear = moment().format("01.01.YYYY");
         const endYear = moment().format("31.12.YYYY");
         return `${startOfYear} - ${endYear}`;
      },
   },
   mounted() {
      function checkConfettiCookie() {
         var cookies = document.cookie.split(";");
         for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf("confettiShown=true") === 0) {
               // The cookie "confettiShown" with value "true" exists
               return true;
            }
         }
         // Cookie not found or doesn't have the desired value
         return false;
      }

      if (!checkConfettiCookie()) {
         this.confettiCookieControl = true;
         // Do something if the cookie "confettiShown" with value "true" exists
      }

      if (!this.showIcon) {
         this.showDropdown = true;
      }
   },
   methods: {
      handlerTriggerRequest() {
         globalService.agencyTarget().then((response) => {
            if (response.result.success) {
               this.response = Object.keys(response.kpis).length != 0 ? this.handlerGenerateTargetList(response.kpis) : null;
               // this.response = this.handlerGenerateTargetList(response.kpis);
               this.handlerAnimateProgress();
            }
         });
      },
      handlerGenerateTargetList(res) {
         const targetList = {};
         for (let item in res) {
            const itemName = item.toLowerCase();
            const itemRatio = Math.floor(res[item].ratio);

            targetList[itemName] = {
               name: itemName,
               targetAsPrice: res[item].goal,
               currentAsPrice: res[item].gsaSales,
               current: itemRatio > 100 ? 100 : itemRatio,
            };
         }

         return targetList;
      },
      handlerOutClick() {
         if (this.showIcon) {
            this.showDropdown = false;
         }
      },
      handlerTargetAchievementStatus() {
         this.showDropdown = true;
      },
      handlerAnimateProgress() {
         this.animationDone = false;
         this.$nextTick(() => {
            const products = document.querySelectorAll(".achievement");

            products.forEach((product) => {
               const achievementPercentage = product.querySelector(".achievement-percentage");
               const emoji = product.querySelector(".achievement-emoji");

               const progressBar = product.querySelector(".progress-bar");
               const progressTooltip = product.querySelector(".progress-tooltip");
               const targetValue = parseInt(progressBar.getAttribute("data-value"));

               // GSAP animation
               // Create a new GSAP timeline
               const tl = gsap.timeline();
               tl.fromTo(
                  progressBar,
                  {
                     width: 0 + "%",
                  },

                  {
                     duration: 2,
                     width: targetValue + "%",
                     ease: "sine",
                     onUpdate: () => {
                        const currentWidth = parseInt(progressBar.style.width);

                        achievementPercentage.innerHTML = `${currentWidth}% Complete`;

                        // Calculate color based on progress value
                        let color;
                        let emojiFace;
                        switch (true) {
                           case currentWidth == 100:
                              color = "#39ca86";
                              emojiFace = "king";
                              if (this.confettiCookieControl) {
                                 this.showConfetti = true;
                              }

                              break;
                           case currentWidth >= 82:
                              color = "#39ca86";
                              emojiFace = "happy";
                              break;
                           case currentWidth >= 66:
                              color = "#BECE4D";
                              emojiFace = "happy";
                              break;
                           case currentWidth >= 50:
                              color = "#fecd32";
                              emojiFace = "normal";
                              break;
                           case currentWidth >= 33:
                              color = "#F8AF40";
                              emojiFace = "normal";
                              break;
                           case currentWidth >= 16:
                              color = "#F3944D";
                              emojiFace = "sad";
                              break;

                           default:
                              color = "#ED6F60";
                              emojiFace = "sad";
                        }

                        function darkenColor(color, amount) {
                           const rgb = parseInt(color.slice(1), 16);

                           let r = (rgb >> 16) & 0xff;
                           let g = (rgb >> 8) & 0xff;
                           let b = rgb & 0xff;

                           r -= amount;
                           g -= amount;
                           b -= amount;
                           // Ensure values are within the valid range [0, 255]
                           r = Math.max(0, Math.min(255, r));
                           g = Math.max(0, Math.min(255, g));
                           b = Math.max(0, Math.min(255, b));

                           return "#" + (b | (g << 8) | (r << 16)).toString(16).padStart(6, "0");
                        }

                        // Adjust color to be slightly darker
                        const darkerColor = darkenColor(color, 10); // Adjust 20 according to your preference

                        // Apply the calculated color to the progress bar
                        progressBar.style.backgroundColor = color;
                        progressTooltip.style.backgroundColor = darkerColor;
                        emoji.style.backgroundColor = color;
                        emoji.setAttribute("class", "achievement-emoji");
                        emoji.classList.add(emojiFace);
                     },
                     onComplete: () => {
                        progressTooltip.style.left = targetValue + "%";
                        tl.to(progressTooltip, {
                           duration: 0.75,
                           opacity: 1,
                           // top: 5,
                           repeat: 0,
                           ease: "power2.out",
                           onComplete: () => {
                              // this.showProgressTooltip = false;
                           },
                        });
                     },
                  }
               );
            });
         });
      },
   },
   watch: {
      showDropdown: {
         handler: function (status) {
            if (status) {
               this.handlerTriggerRequest();
            } else {
               this.response = null;
            }
         },
      },
      showConfetti: {
         handler: function (status) {
            if (status) {
               // Set cookie expiration date 100 days from now
               const expirationDate = new Date();
               expirationDate.setDate(expirationDate.getDate() + 100);

               // Set the cookie
               document.cookie = `confettiShown=true; expires=${expirationDate.toUTCString()}; path=/; secure`;

               setTimeout(() => {
                  this.showConfetti = false;
                  document.querySelector("#confetti-canvas").remove();
                  document.querySelector(".confetti-text-wrapper").remove();
               }, 7000);
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
.target-achievement-container {
   position: relative;
   margin-bottom: 1.5rem;
   &.navbar-style {
      margin-bottom: 0 !important;
      margin-right: 0.5rem;

      .target-achievement-wrapper {
         position: absolute;
         width: 400px;
      }
   }
   .target-achievement-icon-wrapper {
      display: flex;
      height: 100%;
   }

   .target-achievement-wrapper {
      padding: 1.5rem 2rem;
      border-radius: 8px;
      background-clip: padding-box;
      background-color: #fff;
      top: 100%;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 30px 0px;
      width: 100%;
      right: 0;

      .achievement {
         width: 100%;
         display: flex;
         padding-bottom: 1.5rem;
         margin-bottom: 1rem;
         border-bottom: 1px solid #e2e2e2;

         &:last-child {
            border: none;
            padding-bottom: 0;
         }

         .achievement-left {
            width: inherit;
            // cursor: pointer;
            // border: 1px solid;

            .achievement-informations-wrapper {
               display: flex;
               justify-content: space-between;
               align-items: baseline;
               padding-bottom: 0.25rem;

               .achievement-percentage {
                  font-weight: 500;
                  font-size: var(--small);
               }
               .achievement-name {
                  text-transform: capitalize;
               }
            }

            .progress-bar-wrapper {
               // overflow: hidden;
               width: inherit;
               position: relative;
               height: 16px;
               background: #efefef;
               border-radius: 0.25rem;
               cursor: pointer;

               .progress-bar {
                  border-radius: inherit;
                  height: 100%;
               }

               .progress-tooltip {
                  width: fit-content;
                  color: #363636;
                  font-size: var(--xsmall);
                  font-weight: 500;
                  padding: 0.1rem 0.45rem;
                  position: absolute;
                  margin-top: 0.5rem;
                  border-radius: 0.25rem;
                  transform: translateX(calc(-50%));
                  z-index: 9;
                  opacity: 0;
                  margin-top: 1px;

                  &::before {
                     $indicatorSize: 8px;
                     content: "";
                     width: $indicatorSize;
                     height: $indicatorSize;
                     display: block;
                     background-color: inherit;
                     position: absolute;
                     left: 0;
                     right: 0;
                     margin: auto;
                     top: -4px;
                     transform: rotate(45deg);
                  }
               }
            }

            .progress-bar-indicators-wrapper {
               ul {
                  padding: 0 0.25rem;
                  margin-top: 0.125rem;
                  display: flex;
                  justify-content: space-between;
                  &.indicators {
                     li {
                        height: 8px;
                        border-left: 1px solid #a7a7a7;
                        border-radius: 1rem;

                        &:first-child {
                           height: 20px;
                           border-width: 1px;
                        }
                        &:last-child {
                           height: 20px;
                           border-width: 1px;
                           border-style: solid;
                           border-color: #4a4a4a;

                           // border-color:#39ca86;
                        }
                     }
                  }

                  &.indicators-infos {
                     li {
                        font-size: var(--xsmall);
                        font-weight: 500;
                        opacity: 0.75;

                        &:last-child {
                           font-weight: 600;
                           transform: translateX(35%);
                           opacity: 0.85;
                        }
                     }
                  }
               }
            }
         }
         .achievement-right {
            margin-left: 1rem;

            .achievement-emoji {
               width: 36px;
               height: 36px;
               margin-top: 4px;
               border-radius: 50%;
               position: relative;
               display: flex;
               justify-content: center;
               background-color: #ed6f60;
               background-repeat: no-repeat;
               background-position: center;
               transition-duration: 0.5s;
               transition-timing-function: ease-in-out;
               transition-property: all;

               &.king {
                  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDM2IDE3Ij4KICA8cGF0aCBpZD0iUGF0aF85MzI1IiBkYXRhLW5hbWU9IlBhdGggOTMyNSIgZD0iTTkuNTc2LDIxLjUwOGExLDEsMCwwLDEsMS4zNTkuMzY0LDYuOTY4LDYuOTY4LDAsMCwwLDEyLjA2NiwwLC45OTUuOTk1LDAsMSwxLDEuNzIzLDEsOC45NTcsOC45NTcsMCwwLDEtMTUuNTEzLDAsMSwxLDAsMCwxLC4zNjQtMS4zNTlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAzMiAtMTEuMzQ0KSIgZmlsbD0iIzIzMWUxZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+CiAgPHBhdGggaWQ9IlBhdGhfMTEwODUiIGRhdGEtbmFtZT0iUGF0aCAxMTA4NSIgZD0iTTEzLjk1NCwxNC4yMzVjMCwyLDIuMzg0LDIuOTg1LjU3NSwyLjk4NWEzLjE0MywzLjE0MywwLDAsMS0zLjI3OC0yLjk4NSwzLjE0MywzLjE0MywwLDAsMSwzLjI3OC0yLjk4NUMxNi4zMzgsMTEuMjUsMTMuOTU0LDEyLjIzMywxMy45NTQsMTQuMjM1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzcuMTQgLTkuMzczKSByb3RhdGUoOTApIiBmaWxsPSIjMjMxZTFmIi8+CiAgPHBhdGggaWQ9IlBhdGhfMTEwODYiIGRhdGEtbmFtZT0iUGF0aCAxMTA4NiIgZD0iTTEzLjk1NCwxNC4yMzVjMCwyLDIuMzg0LDIuOTg1LjU3NSwyLjk4NWEzLjE0MywzLjE0MywwLDAsMS0zLjI3OC0yLjk4NSwzLjE0MywzLjE0MywwLDAsMSwzLjI3OC0yLjk4NUMxNi4zMzgsMTEuMjUsMTMuOTU0LDEyLjIzMywxMy45NTQsMTQuMjM1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjguMjE5IC05LjM3Mykgcm90YXRlKDkwKSIgZmlsbD0iIzIzMWUxZiIvPgogIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTMzMyIgZGF0YS1uYW1lPSJFbGxpcHNlIDEzMzMiIGN4PSIyLjUiIGN5PSIyLjUiIHI9IjIuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNiA2KSIgZmlsbD0iI2NmNTZlYyIvPgogIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTMzNCIgZGF0YS1uYW1lPSJFbGxpcHNlIDEzMzQiIGN4PSIyLjUiIGN5PSIyLjUiIHI9IjIuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjUgNikiIGZpbGw9IiNjZjU2ZWMiLz4KPC9zdmc+Cg==");

                  &::before {
                     background-image: url("data:image/svg+xml;base64,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");
                     background-repeat: no-repeat;
                     background-position: center;
                     position: absolute;
                     display: block;
                     width: 25px;
                     height: 15px;
                     content: "*";
                     text-indent: -999em;
                     transform: scale(1.26);
                     left: -1.5px;
                     top: -8px;
                  }
               }
               &.happy {
                  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iZW1vamktc21pbGUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE1Ljc4IiBoZWlnaHQ9IjE0LjkyMyIgdmlld0JveD0iMCAwIDE1Ljc4IDE0LjkyMyI+CiAgPHBhdGggaWQ9IlBhdGhfOTMyNSIgZGF0YS1uYW1lPSJQYXRoIDkzMjUiIGQ9Ik05LjU3NiwyMS41MDhhMSwxLDAsMCwxLDEuMzU5LjM2NCw2Ljk2OCw2Ljk2OCwwLDAsMCwxMi4wNjYsMCwuOTk1Ljk5NSwwLDEsMSwxLjcyMywxLDguOTU3LDguOTU3LDAsMCwxLTE1LjUxMywwLDEsMSwwLDAsMSwuMzY0LTEuMzU5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkuMDc4IC0xMi40MjEpIiBmaWxsPSIjMjMxZTFmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICA8cGF0aCBpZD0iUGF0aF85MzI2IiBkYXRhLW5hbWU9IlBhdGggOTMyNiIgZD0iTTE1LjIzLDE0LjIzNWMwLDEuNjQ4LS44OTEsMi45ODUtMS45OSwyLjk4NXMtMS45OS0xLjMzNy0xLjk5LTIuOTg1Ljg5MS0yLjk4NSwxLjk5LTIuOTg1UzE1LjIzLDEyLjU4NywxNS4yMywxNC4yMzVabTcuOTU5LDBjMCwxLjY0OC0uODkxLDIuOTg1LTEuOTksMi45ODVzLTEuOTktMS4zMzctMS45OS0yLjk4NVMyMC4xLDExLjI1LDIxLjIsMTEuMjUsMjMuMTg5LDEyLjU4NywyMy4xODksMTQuMjM1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkuMzI5IC0xMS4yNSkiIGZpbGw9IiMyMzFlMWYiLz4KPC9zdmc+Cg==") !important;
               }
               &.normal {
                  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iZW1vamktbmV1dHJhbCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNiAxMiI+CiAgPHBhdGggaWQ9IlBhdGhfOTMyMiIgZGF0YS1uYW1lPSJQYXRoIDkzMjIiIGQ9Ik05LDIzLjVhMSwxLDAsMCwxLDEtMUgyNGExLDEsMCwwLDEsMCwySDEwQTEsMSwwLDAsMSw5LDIzLjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOSAtMTIuNSkiIGZpbGw9IiMyMzFmMjAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogIDxwYXRoIGlkPSJQYXRoXzkzMjMiIGRhdGEtbmFtZT0iUGF0aCA5MzIzIiBkPSJNMTUuMjUsMTQuMjVjMCwxLjY1Ni0uOSwzLTIsM3MtMi0xLjM0NC0yLTMsLjktMywyLTNTMTUuMjUsMTIuNTk0LDE1LjI1LDE0LjI1Wm04LDBjMCwxLjY1Ni0uOSwzLTIsM3MtMi0xLjM0NC0yLTMsLjktMywyLTNTMjMuMjUsMTIuNTk0LDIzLjI1LDE0LjI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkuMjUgLTExLjI1KSIgZmlsbD0iIzIzMWYyMCIvPgo8L3N2Zz4K") !important;
               }
               &.sad {
                  background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iZW1vamktZnJvd24iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE1Ljg2MSIgaGVpZ2h0PSIxNS4wMDEiIHZpZXdCb3g9IjAgMCAxNS44NjEgMTUuMDAxIj4KICA8cGF0aCBpZD0iUGF0aF85MzI4IiBkYXRhLW5hbWU9IlBhdGggOTMyOCIgZD0iTTkuNTc4LDI3LjI0MWExLDEsMCwwLDAsMS4zNjYtLjM2Niw3LDcsMCwwLDEsMTIuMTI4LDAsMSwxLDAsMSwwLDEuNzMyLTEsOSw5LDAsMCwwLTE1LjU5MywwLDEsMSwwLDAsMCwuMzY3LDEuMzY1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkuMDc4IC0xMi4zNzUpIiBmaWxsPSIjMjExZjIwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICA8cGF0aCBpZD0iUGF0aF85MzI5IiBkYXRhLW5hbWU9IlBhdGggOTMyOSIgZD0iTTE1LjI1LDE0LjI1YzAsMS42NTYtLjksMy0yLDNzLTItMS4zNDQtMi0zLC45LTMsMi0zUzE1LjI1LDEyLjU5NCwxNS4yNSwxNC4yNVptOCwwYzAsMS42NTYtLjksMy0yLDNzLTItMS4zNDQtMi0zLC45LTMsMi0zUzIzLjI1LDEyLjU5NCwyMy4yNSwxNC4yNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05LjMxOSAtMTEuMjUpIiBmaWxsPSIjMjExZjIwIi8+Cjwvc3ZnPgo=") !important;
               }
            }
         }
      }

      .info-bar-wrapper {
         display: flex;
         background-color: #e3f2fc;
         padding: 0.25rem 0.5rem;
         border-radius: 0.25rem;

         .info-icon {
            display: flex;
            width: 16px !important;
            height: 16px !important;
            min-width: 16px !important;
            background-size: cover;
            background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfMTE3OTIiIGRhdGEtbmFtZT0iR3JvdXAgMTE3OTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxwYXRoIGlkPSJFbGxpcHNlXzEzMTMiIGRhdGEtbmFtZT0iRWxsaXBzZSAxMzEzIiBkPSJNOCwwQTgsOCwwLDEsMSwwLDgsOCw4LDAsMCwxLDgsMFoiIGZpbGw9IiMyZTY3YjgiLz4KICA8ZyBpZD0iR3JvdXBfMTE3NzEiIGRhdGEtbmFtZT0iR3JvdXAgMTE3NzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuNTc0IDMuODM0KSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xMDM2OSIgZGF0YS1uYW1lPSJQYXRoIDEwMzY5IiBkPSJNMTcuMDM1LDE0LjgyM2wtMi4yNy4yODUtLjA4MS4zNzcuNDQ2LjA4MmMuMjkxLjA3LjM0OS4xNzQuMjg2LjQ2NWwtLjczMSwzLjQzOGMtLjE5Mi44ODkuMSwxLjMwOC44LDEuMzA4YTIuMDUzLDIuMDUzLDAsMCwwLDEuNDUyLS41OTNsLjA4Ny0uNDEyYTEuMSwxLjEsMCwwLDEtLjY4LjI0NGMtLjI3MywwLS4zNzItLjE5MS0uMy0uNTI4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0LjYyNyAtMTEuNzYyKSIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTAzNzAiIGRhdGEtbmFtZT0iUGF0aCAxMDM3MCIgZD0iTTE3LjczMyw4Ljg2NmEuOTkxLjk5MSwwLDEsMS0uOTkxLS45OTFBLjk5MS45OTEsMCwwLDEsMTcuNzMzLDguODY2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1LjI1NSAtNy44NzUpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K");
         }
         .info-text {
            margin-left: 8px;
            color: var(--primary);
            font-size: var(--xsmall);
            font-weight: 500;
         }
      }
   }
}
</style>
